<template>
	<div class="material dropdown" v-bind:class="{
		'focus': focus,
		'has-value': !! input,
		'show-filter': show_filter,
	}">
		<div class="label">{{ label }}</div>
		<select v-model="input" v-on:focus="focus = true;" v-on:blur="focus = false;" v-on:change="$emit('change')">
			<option v-for="(option, key) in list" :value="key">{{ option }}</option>
		</select>
		<SvgIcon class="search-icon" size="22" name="search" v-on:click="toggleShowFilter()" />
		<div class="filter-wrapper">
			<MaterialText ref="filter" class="filter" label="Search for" v-model="filter" />
		</div>
	</div>
</template>

<script>
export default {
  props: [
    'value',
    'label',
    'options',
    'sort'
  ],
  data: () => ({
    focus: false,
    filter: '',
    show_filter: false
  }),
  computed: {
    input: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    list () {
      var result = this.options

      if (this.sort) {
        var list = this.options
        var sortedList = {}
        Object.keys(list).sort((a, b) => list[a] - list[b]).forEach((key) => {
						    sortedList[key] = list[key]
        })
        result = sortedList
      }

      if (this.filter) {
        var res = {}
        for (var i in result) {
          if (result[i].indexOf(this.filter) >= 0) {
            res[i] = result[i]
          }
        }
        result = res
      }

      return result
    }
  },
  methods: {
    toggleShowFilter () {
      this.show_filter = !this.show_filter

      if (this.show_filter) {
        this.$refs.filter.focus()
      }
    }
  }
}
</script>
